"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateShiftsPublish = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const shiftsPublishMutation = (0, graphql_tag_1.default) `
  mutation ShiftsPublish($workspace: ID!, $ids: [ID!]) {
    shiftsPublish(workspaceId: $workspace, ids: $ids)
  }`;
const mutateShiftsPublish = async (args) => {
    const { data, errors } = await (0, apollo_1.mutate)(shiftsPublishMutation, {
        variables: args
    });
    (0, error_handler_1.processErrors)(errors, (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ANNOUNCE_SHORTER')));
    return data?.shiftsPublish;
};
exports.mutateShiftsPublish = mutateShiftsPublish;
